/**
 * A/B Test: Bundle selection panel (MoonBundle + Rapi Bundle)
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-bundle-test="true"  → Test A / control — selection panel as-is
 *   data-elios-bundle-test="false" → Test B / variant — select last option, hide full panel
 */
(function () {
  'use strict';

  if (window.__eliosBundleABTestInit) return;
  window.__eliosBundleABTestInit = true;

  var BODY_ATTR = 'data-elios-bundle-test';
  var HIDDEN_ATTR = 'data-elios-bundle-ab-hidden';
  var MOON_OPTION = '.moonbundle-option-wrapper';
  var MOON_ROOTS = 'moonbundle-component, .moonbundle-box';
  var MOON_PANEL =
    '.moonbundle-options-horizontal, .moonbundle-options-vertical, .moonbundle-options, .moonbundle-box';
  var RAPI_BAR = '.rapi-bundles__bar';
  var RAPI_CONTAINER = '.rapi-bundles__bars';
  var RAPI_PANEL = '.rapi-bundles, .rapi-bundles__bars';
  var timer = null;
  var busy = false;
  var pollTimer = null;
  var pollUntil = 0;

  function isVariantTest() {
    var value = document.body && document.body.getAttribute(BODY_ATTR);
    return String(value).toLowerCase() === 'false';
  }

  function hideNode(node) {
    if (!node || node.getAttribute(HIDDEN_ATTR) === 'true') return;
    node.setAttribute(HIDDEN_ATTR, 'true');
    node.setAttribute('hidden', '');
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  }

  function showNode(node) {
    if (!node) return;
    node.removeAttribute(HIDDEN_ATTR);
    node.removeAttribute('hidden');
    node.style.removeProperty('display');
    node.removeAttribute('aria-hidden');
  }

  function isMoonOptionSelected(option) {
    if (!option) return false;
    if (option.classList && option.classList.contains('moonbundle-option-active')) return true;
    if (option.querySelector('.moonbundle-option-active')) return true;
    if (option.getAttribute('aria-checked') === 'true') return true;
    var radio = option.querySelector('input[type="radio"]');
    return !!(radio && radio.checked);
  }

  function isRapiBarSelected(bar) {
    if (!bar) return false;
    if (bar.getAttribute('aria-checked') === 'true') return true;
    if (bar.className && String(bar.className).indexOf('selected') > -1) return true;
    var radio = bar.querySelector('input[type="radio"]');
    return !!(radio && radio.checked);
  }

  function enableUpsellToggles(scope) {
    if (!scope) return;

    scope
      .querySelectorAll(
        'input[type="checkbox"], input[type="radio"].moonbundle-upsell-checkbox, .moonbundle-upsell-item input, [class*="upsell"] input[type="checkbox"]'
      )
      .forEach(function (input) {
        if (input.disabled) return;
        if (input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

    scope.querySelectorAll('[role="switch"], .moonbundle-switch, [class*="toggle"], [class*="switch"]').forEach(function (el) {
      var pressed = el.getAttribute('aria-checked') || el.getAttribute('aria-pressed');
      if (pressed === 'true') return;
      if (el.classList && (el.classList.contains('is-on') || el.classList.contains('active') || el.classList.contains('checked'))) {
        return;
      }
      el.click();
    });
  }

  function selectMoonOption(option) {
    if (!option) return;

    var radio = option.querySelector('input[type="radio"]');
    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var target =
      option.querySelector('#moonbundle-option, .moonbundle-option[role="button"], .moonbundle-option, [role="radio"]') ||
      option;
    if (target && typeof target.click === 'function') {
      target.click();
    }

    enableUpsellToggles(option);
  }

  function selectRapiBar(bar) {
    if (!bar) return;

    var radio = bar.querySelector('input[type="radio"]');
    if (radio && !radio.disabled) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    bar.click();
    enableUpsellToggles(bar);
  }

  function getLastMoonOption(root) {
    var options = root.querySelectorAll(MOON_OPTION);
    if (!options.length) return null;
    return options[options.length - 1];
  }

  function getLastRapiBar(container) {
    var bars = container.querySelectorAll(':scope > ' + RAPI_BAR);
    if (!bars.length) bars = container.querySelectorAll(RAPI_BAR);
    if (!bars.length) return null;
    return bars[bars.length - 1];
  }

  function hideMoonPanel(root) {
    var panel = root.matches && root.matches(MOON_PANEL) ? root : null;
    if (!panel) panel = root.querySelector(MOON_PANEL);
    if (!panel) panel = root;
    hideNode(panel);

    if (root !== panel && root.tagName && root.tagName.toLowerCase() === 'moonbundle-component') {
      hideNode(root);
    }
  }

  function hideRapiPanel(container) {
    var panel = container.closest('.rapi-bundles') || container;
    hideNode(panel);
    if (panel !== container) hideNode(container);
  }

  function restoreMoonPanels() {
    document.querySelectorAll(MOON_ROOTS + ', ' + MOON_PANEL + ', ' + MOON_OPTION).forEach(showNode);
  }

  function restoreRapiPanels() {
    document.querySelectorAll(RAPI_PANEL + ', ' + RAPI_BAR).forEach(showNode);
  }

  function applyMoonBundles(hidePanel) {
    document.querySelectorAll(MOON_ROOTS).forEach(function (root) {
      var last = getLastMoonOption(root);
      if (!last) return;

      if (!hidePanel) return;

      if (!isMoonOptionSelected(last)) {
        selectMoonOption(last);
      } else {
        enableUpsellToggles(last);
      }

      hideMoonPanel(root);
    });
  }

  function applyRapiBundles(hidePanel) {
    document.querySelectorAll(RAPI_CONTAINER).forEach(function (container) {
      var last = getLastRapiBar(container);
      if (!last) return;

      if (!hidePanel) return;

      if (!isRapiBarSelected(last)) {
        selectRapiBar(last);
      } else {
        enableUpsellToggles(last);
      }

      hideRapiPanel(container);
    });
  }

  function applyTest() {
    if (busy) return;
    busy = true;

    try {
      var hidePanel = isVariantTest();

      document.body.classList.toggle('elios-bundle-test-a', !hidePanel);
      document.body.classList.toggle('elios-bundle-test-b', hidePanel);

      restoreMoonPanels();
      restoreRapiPanels();

      applyMoonBundles(hidePanel);
      applyRapiBundles(hidePanel);

      if (hidePanel && Date.now() < pollUntil) {
        startPolling();
      }
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(applyTest, 50);
  }

  function startPolling() {
    if (pollTimer) return;

    pollTimer = window.setInterval(function () {
      applyTest();

      if (Date.now() >= pollUntil) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 400);
  }

  function armPolling() {
    pollUntil = Date.now() + 30000;
    startPolling();
  }

  function init() {
    applyTest();
    armPolling();

    new MutationObserver(schedule).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR]
    });

    new MutationObserver(function () {
      schedule();
      if (isVariantTest()) armPolling();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });

    [400, 1200, 2500, 5000, 8000, 12000, 18000, 25000, 30000].forEach(function (delay) {
      window.setTimeout(applyTest, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    schedule();
    armPolling();
  });
})();
